import { api } from "@libs/api/client";
import type { ApiBodyNested } from "@libs/api/types";

export type reportSealBody = ApiBodyNested<["report", "seal"], "post">;

export const reportSeal = async (body: reportSealBody) => {
  const { data } = await api.report.seal.post(body);
  return data;
};

